import {
    TOKEN_ANALYZER_WELCOME,
    TOKEN_ANALYZER_STATS_SETTED,
    TOKEN_ANALYZER_PROCESSING,
    TOKEN_ANALYZER_STATS_PROCESSING
} from "../consts/consts";

const initialState = {
    status: TOKEN_ANALYZER_WELCOME
};

const processingState = {
    status: TOKEN_ANALYZER_PROCESSING
};

const updateTokenAnalyzer = (state, action) => {

    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case TOKEN_ANALYZER_STATS_SETTED:
            return action.payload;
        case TOKEN_ANALYZER_STATS_PROCESSING:
            return processingState;
        default:
            return state.tokenAnalyzer;
    }

};

export {
    updateTokenAnalyzer
}